import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import bankJournal from '../../../assets/img/bookkeeping/jurnal_bank.png';
import bankCash from '../../../assets/img/bookkeeping/jurnal_kas.png';

export default class Spp extends PureComponent {
  constructor(props) {
    super(props);
    this.clickHandlers = {};
    this.onClick = this.onClick.bind(this);
    this.onClickTableControl = this.onClickTableControl.bind(this);
    this.onClickMasterData = this.onClickMasterData.bind(this);
    this.onClickCreateInvoice = this.onClickCreateInvoice.bind(this);
    this.onClickProsesPembayaran = this.onClickProsesPembayaran.bind(this);
    this.onClickLaporanKau = this.onClickLaporanKau.bind(this);
  }
  

  onClick(link) {
    const { history } = this.props;
    history.push(`/dashboard/keuangan/pembukuan/${link}`);
  }


  getClickHandler(link) {
    if (!Object.prototype.hasOwnProperty.call(this.clickHandlers, link)) {
      this.clickHandlers[link] = () => this.onClick(link);
    }
    return this.clickHandlers[link];
  }
  onClickTableControl() {
    const { history } = this.props;
    history.push(`/dashboard/keuangan/spp/nama-pembayaran`);

  }
  onClickMasterData() {
    const { history } = this.props;
    history.push(`/dashboard/keuangan/spp/master-data-keuangan`);

  }

  onClickLaporanKau() {
    const { history } = this.props;
    history.push(`/dashboard/keuangan/spp/laporan-spp`);

  }

  onClickCreateInvoice() {
    const {history} = this.props;
    history.push(`/dashboard/keuangan/spp/create-invoice`);
  }

  onClickProsesPembayaran() {
    const {history} = this.props;
    history.push(`/dashboard/keuangan/spp/pembayaran`);
  }

  render() {
    return (
      <div className="bookkeeping">
        <div className="bookkeeping__list">
          <button onClick={this.onClickTableControl}>
            <img src={bankJournal} alt="Table Kontrol Keuangan" />
            <h3>Jenis SPP</h3>
          </button>
        </div>
        
        <div className="bookkeeping__list">
          <button onClick={this.onClickCreateInvoice}>
            <img src={bankJournal} alt="create invoice" />
            <h3>Create Invoice</h3>
          </button>
        </div>
        <div className="bookkeeping__list">
          <button onClick={this.onClickProsesPembayaran}>
            <img src={bankJournal} alt="proses pembayaran" />
            <h3>Pembayaran</h3>
          </button>
        </div>
        <div className="bookkeeping__list">
          <button onCLick={this.onClickLaporanKau}>
            <img src={bankJournal} alt="LaporanKeu" />
            <h3>Laporan Keuangan</h3>
          </button>
        </div>
        
        
      </div>
    );
  }
}
Spp.propTypes = {
  history: PropTypes.object.isRequired,
};
